import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=6f0e8b7f"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoveryPassword.vue?vue&type=style&index=0&id=6f0e8b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports